import pendingSubmissionsCountSelectorFactory from '../../gridReport/pendingSubmissionsCountSelectorFactory';
import columnDefinitionsSelectorFactory from '../columnDefinitions';

import { isAllowedToMakeDirectEntriesSelectorFactory } from '../../store/selectors';

export const pendingSubmissionsCountSelector = ({ balanceSheetManagement }) =>
  pendingSubmissionsCountSelectorFactory(balanceSheetManagement.deferredRollforward.reportData);

export const isFetchingDeferredRollforwardReportSelector = ({ balanceSheetManagement }) =>
  balanceSheetManagement.deferredRollforward.isFetchingReportData;

export const isExportingDeferredRollforwardReportSelector = ({ balanceSheetManagement }) =>
  balanceSheetManagement.deferredRollforward.isExportingReport;

export const aggregationDroplistValueSelector = ({ balanceSheetManagement }) =>
  balanceSheetManagement.deferredRollforward.aggregationDroplistValue;

export const reportDataSelector = state => state.balanceSheetManagement.deferredRollforward.reportData;

const isAllowedToMakeDirectEntriesSelector = isAllowedToMakeDirectEntriesSelectorFactory({
  checkAggregationDroplistValue: true,
});

export const columnDefinitionsSelector = columnDefinitionsSelectorFactory(
  aggregationDroplistValueSelector,
  reportDataSelector,
  isAllowedToMakeDirectEntriesSelector
);

export const obligationsSelector = ({ administration }) =>
  administration.obligations.obligations;

export const periodOrCurrentSelector = ({ shared }) => shared.period || shared.currentPeriod;
